export const SYNC_ACCOUNT = 'SYNC_ACCOUNT';
export const UPDATE_CARD = 'UPDATE_CARD';
export const CLEANUP = 'CLEANUP';
export const ON_ERROR = 'ON_ERROR';
export const FETCH_CONTEXT = 'FETCH_CONTEXT';
